var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.6667 2H2.33333C1.04514 2 0 3.04514 0 4.33333V19.8889C0 21.1771 1.04514 22.2222 2.33333 22.2222H11.6667L10.8889 24.5556H7.38889C6.74722 24.5556 6.22222 25.0806 6.22222 25.7222C6.22222 26.3639 6.74722 26.8889 7.38889 26.8889H20.6111C21.2552 26.8889 21.7778 26.3663 21.7778 25.7222C21.7778 25.0781 21.2552 24.5556 20.6111 24.5556H17.1111L16.3333 22.2222H25.6667C26.9549 22.2222 28 21.1771 28 19.8889V4.33333C28 3.04514 26.9549 2 25.6667 2ZM24.8889 16H3.11111V5.11111H24.8889V16Z"}));
}

Desktop.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Desktop;

Desktop.default = Desktop;
